import { FirebaseMessagingTypes } from '@react-native-firebase/messaging';
import { get } from 'lodash';
import moment from 'moment-jalaali';

import { Notification as Data } from '@src/types';

import generateUser from './user';

const Factory = (api: FirebaseMessagingTypes.RemoteMessage): Data => {
  let user;
  try {
    user = JSON.parse(get(api, 'data.person'));
  } catch (e) {
    user = get(api, 'data.person');
  }
  const cover = get(api, 'data.imageUrl');
  const link = get(api, 'data.link');

  return {
    id: api.messageId ?? '',
    type: get(api, 'data.notificationType'),
    user: user ? generateUser(user) : undefined,
    cover: cover ? { uri: cover } : undefined,
    link: link ? link : undefined,
    entityType: get(api, 'data.entityType'),
    entityId: get(api, 'data.entityId'),
    count: 0,
    content: get(api, 'data.text'),
    seen: false,
    date: moment.unix(moment.now()),
  };
};

export default Factory;
